<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appCostCenter></appCostCenter>
        <appOtherOptionsTable v-if="!getIsNoConfig">
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appOptionsTable v-if="!getIsNoConfig">
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <div class="price-qty--container matrix_table">
          <div class="price-qty--elem qty--container">
            <div class="matrix_tableHeader">
              {{ $t("Order quantity") }}
            </div>
            <appQuantitySelectionContainer></appQuantitySelectionContainer>
          </div>
          <div class="price-qty--elem price--container">
            <div class="price--label">
              {{ $t("Total price (gross) incl. shipping") }}
            </div>
            <div v-if="getTotalOldPrice" class="price--value">
              <span class="old-price price"> {{ getTotalOldPrice }}</span>
              <span class="amount--total discounted"> {{ getTotalPrice }}</span>
            </div>
            <div v-else class="price--value">
              <span class="amount--total">{{ getTotalPrice }}</span>
            </div>
          </div>
        </div>

        <div class="actions--container matrix_table">
          <div class="matrix_tableHeader">
            {{ getActionsTitle }}
          </div>
          <appPersonalizationButton
            v-show="getPersonalizationFullPage"
            v-if="!getUploadPersonalizationOneProduct && !getIsNoPers"
          ></appPersonalizationButton>
          <appUploadTable
            v-if="!getIsNoUpload"
            alwaysShow="true"
            :class="!getUploadsForPP.length ? 'notUploaded' : ''"
          ></appUploadTable>
          <appAddToCartButton
            v-show="
              getAddToCartFullPage || getPersonalizationStatus || getIsNoPers
            "
          ></appAddToCartButton>
        </div>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
        </appQuantityTable>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useUploadsStore } from "@/stores/modules/uploads";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n.js";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getTotalPrice", "getTotalOldPrice"]),
    ...mapState(useConfigStore, [
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ]),
    ...mapState(useWebproductStore, [
      "getUploadPersonalizationOneProduct",
      "getIsNoConfig",
      "getIsNoUpload",
      "getIsNoPers"
    ]),
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"]),
    ...mapState(useUploadsStore, ["getUploadsForPP"]),
    getActionsTitle: function () {
      let title = i18n.t("Add To Cart");
      if (!this.getIsNoUpload) {
        title = i18n.t("Upload");
      }
      if (!this.getUploadPersonalizationOneProduct && !this.getIsNoPers) {
        title = i18n.t("3D-DESIGNER");
      }
      return title;
    }
  }
};
</script>
